(ns app.front.ui.updated
  (:require [core.front.date-util :as date-util]
            [core.front.event :refer [<sub]]
            [potpuri.core :as p]))

(def update-trs
  [[60 :update-time-v2/hour :update-time-v2/hours]
   [24 :update-time-v2/day :update-time-v2/days]
   [7 :update-time-v2/week :update-time-v2/weeks]
   ;; (/ (+ 31 28 31 30 31 30 31 31 30 31 30 31) 12 7) => 4.345238095...
   [4.34524 :update-time-v2/month :update-time-v2/months]
   [12 :update-time-v2/year :update-time-v2/years]])

(defn get-time-and-tr-keys [interval-minutes]
  (reduce (fn [[remaining :as prev] [duration & trs]]
            (let [remaining-new (/ remaining duration)]
              (if (> 0.9 remaining-new)
                (reduced prev)
                (concat [remaining-new] trs))))
          [interval-minutes :update-time-v2/min :update-time-v2/mins]
          update-trs))

(defn updated [{:keys [ts user verb-tr-key]}]
  (when ts
    (let [tr              (<sub [:tr])
          date-time       (<sub [::date-util/date-time-fn])
          [diff
           tr-key
           tr-key-plural] (-> (- (js/Date.) ts)
                              (/ 1000 60)
                              get-time-and-tr-keys)
          number          (js/Math.round diff)
          plural?         (> number 1)
          action-tr-key   (p/condas-> (or verb-tr-key :update-time-v2/updated) k
                            user (keyword "update-time-v2" (str (name k) "-by")))]
      [:span {:title (date-time ts)}
       (tr [(if user
              :update-time-v2/verb-ago-by-structure
              :update-time-v2/verb-ago-structure)]
           [(tr [action-tr-key])
            (tr [(if plural? tr-key-plural tr-key)]
                [(js/Math.round diff)])
            (tr [:update-time-v2/by]
                [user])])])))
